import { render, staticRenderFns } from "./LegacyDialogPrompt.vue?vue&type=template&id=48faebc7&scoped=true"
import script from "./LegacyDialogPrompt.vue?vue&type=script&lang=ts"
export * from "./LegacyDialogPrompt.vue?vue&type=script&lang=ts"
import style0 from "./LegacyDialogPrompt.vue?vue&type=style&index=0&id=48faebc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48faebc7",
  null
  
)

export default component.exports